// extracted by mini-css-extract-plugin
export default {"mobile":"App_mobile__H7tzD","marginTop4":"App_marginTop4__4F0p+"};